/* eslint-disable @atlaskit/design-system/no-unsafe-style-overrides */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css as cssUnbounded } from '@compiled/react';
import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/default/button';
import IconButton from '@atlaskit/button/icon/button';
import { jsx, css } from '@atlaskit/css';
import VideoStopOverlayIcon from '@atlaskit/icon/core/video-stop-overlay';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { token } from '@atlaskit/tokens';

import messages from './messages';

type Props = {
	autoFocus?: boolean;
	isAIFC?: boolean;
	onCancel: () => void;
};

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const escTextStylesUnbounded = cssUnbounded({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	padding: '3px',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	marginLeft: '5px',
});

// no tokens for 3px exist, so using raw values
const escTextStyles = css({
	borderRadius: token('radius.small'),
	color: token('color.text.subtle'),
	backgroundColor: token('color.background.neutral'),
	fontWeight: token('font.weight.regular'),
});

export const CancelEscButton = ({ onCancel, autoFocus, isAIFC }: Props): JSX.Element => {
	const { formatMessage } = useIntl();
	return isAIFC ? (
		<IconButton
			label={formatMessage(messages.labelCancel)}
			// eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
			icon={() => <VideoStopOverlayIcon label="" color={token('color.icon.danger')} />}
			shape="default"
			onClick={onCancel}
			autoFocus={autoFocus}
			appearance="subtle"
		/>
	) : (
		<Button autoFocus={autoFocus} testId="cancel-esc-button" type="button" onClick={onCancel}>
			{formatMessage(messages.labelCancel)}
			{/* ignore use-primitives-text below as it affects focus and all styles inside and outside the button */}
			{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text -- Ignored via go/DSP-18766 */}
			<span css={[escTextStyles, escTextStylesUnbounded]}>{formatMessage(messages.labelEsc)}</span>
		</Button>
	);
};
